export default {
  'menu.welcome': '首页',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.ai-subtitles.translation': '字幕翻译',
  'menu.ai-subtitles.translation.list': '翻译列表',
  'menu.ai-subtitles.translation.action': '翻译配置',
  'menu.sys-menu': '系统管理',
  'menu.sys-menu.menumanagement': '菜单管理',
  'menu.sys-menu.rolemenu': '角色管理',
  'menu.sys-menu.usermenu': '用户管理',
  'menu.ai-subtitles.subtitleremoval': '字幕处理',
  'menu.ai-subtitles': 'AI短剧Play',
  'menu.ai-subtitles.subtitleremoval.list': '字幕列表',
  'menu.ai-subtitles.subtitleremoval.upload': '视频上传',
  'menu.ai-subtitles.subtitleremoval.download': '下载任务',
  'menu.usermanagement': '成员管理',
  'menu.usermanagement.settings': '成员列表',
  'menu.generateImg': 'AI素材Muse',
  'menu.generateImg.chat-image': 'AI对话生图',
  'menu.generateImg.chat-reel': 'AI短视频Reel',
  'menu.generateImg.image': '图片生成',
  'menu.generateImg.image-edit': '图片修改',
  'menu.generateImg.video': '视频生成',
  'menu.generateImg.image.img-generation': '文生图片',
  'menu.generateImg.image.img-edit': '多图参考',
  'menu.generateImg.video.video-generation': '文生视频',
  'menu.generateImg.video.img-video': '图生视频',
  'menu.generateImg.video.video-extend': '视频扩展',
  'menu.generateImg.img-outpaint': '图片扩展',
  'menu.generateImg.img-insert': '图片嵌入',
  'menu.generateImg.img-remove': '图片擦除',
  'menu.generateImg.img-product-showcase': '换景展示',
  'menu.generateImg.img-transform': '图片转换',
  'menu.generateImg.image-edit.img-ai-chat': '对话改图🍌',
  'menu.generateImg.image-edit.img-mask-edit': '蒙版改图',
  'menu.generateImg.image-edit.img-free-morph': '自由改图',
  'menu.ai-analysis': 'AI洞察Insight',
  'menu.ai-subtitles.subtitle-suppression': '字幕压制',
  'menu.ai-subtitles.subtitle-suppression.list': '压制列表',
  'menu.ai-subtitles.subtitle-suppression.detail': '压制详情',
  'menu.ai-subtitles.subtitle-suppression.create': '新建任务',
  'menu.ai-subtitles.subtitle-suppression.download': '下载任务',
  'menu.ai-subtitles.video-translation': '视频配音',
  'menu.ai-subtitles.video-translation.video-list': '任务列表',
  'menu.ai-subtitles.video-translation.translation-config': '任务配置',
  'menu.ai-subtitles.video-translation.download': '下载任务',
  'menu.ai-subtitles.video-translation.manual-proofreading': '人工校对',
  'menu.seo-creation': 'AI SEO Blog',
  'menu.seo-creation.blog-creation': 'SEO Blog Agent',
  'menu.seo-creation.keyword-assets': '关键词资产',
  'menu.seo-creation.data-analysis': '数据分析',
  'menu.seo-creation.batch-creation': '批量创作',
  'menu.session-history': '历史记录',
  'menu.session-history.all': '全部项目',
  'menu.account-info': '用量统计',
  'menu.account-info.info': '账单明细',
  'menu.integration': '集成中心',
};
